// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Raw_js_utils = require("../utils/Raw_js_utils.res.js");

function createTransformFromObject(obj) {
  return {
          canApply: (function (params) {
              return obj.canApply(params);
            }),
          displayName: (function (params) {
              return obj.displayName(params);
            }),
          createInitialState: (function (params) {
              return obj.createInitialState(params);
            }),
          renderDialog: (function (params) {
              return obj.renderDialog(params);
            })
        };
}

function stringToFragTransforms(str) {
  var msg = Raw_js_utils.invokeExnFunc("Execute the transforms script", (function () {
          return Raw_js_utils.executeFunctionBody(str);
        }));
  if (msg.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: msg._0
          };
  }
  var transforms = msg._0;
  return Raw_js_utils.invokeExnFunc("Convert objects from the transforms script to internal representation", (function () {
                return transforms.map(createTransformFromObject);
              }));
}

function arrStrToFragTransforms(texts) {
  return Core__Array.reduce(texts, {
              TAG: "Ok",
              _0: []
            }, (function (res, text) {
                if (res.TAG !== "Ok") {
                  return res;
                }
                var msg = stringToFragTransforms(text);
                if (msg.TAG === "Ok") {
                  return {
                          TAG: "Ok",
                          _0: res._0.concat(msg._0)
                        };
                } else {
                  return {
                          TAG: "Error",
                          _0: msg._0
                        };
                }
              }));
}

function reactElemDtoToObj(prim) {
  return prim;
}

function objToObj(prim) {
  return prim;
}

function objToFragmentTransformState(prim) {
  return prim;
}

exports.reactElemDtoToObj = reactElemDtoToObj;
exports.objToObj = objToObj;
exports.objToFragmentTransformState = objToFragmentTransformState;
exports.arrStrToFragTransforms = arrStrToFragTransforms;
/* Raw_js_utils Not a pure module */
